// Social links block schema - Social media icon row
// Now syncs automatically with profile data instead of manual URL entry
export const socialLinksSchema = {
  type: 'social-links',
  label: 'Social & Chess Links',
  description: 'Display your social media and chess profile links',
  icon: 'Share2',
  defaultContent: {
    heading: '',
    alignment: 'center', // 'left' | 'center' | 'right'
    size: 'medium', // 'small' | 'medium' | 'large'
    iconStyle: 'filled', // 'filled' | 'outline' | 'minimal'
    // Which platforms to show (empty array = show all that have values)
    visiblePlatforms: [],
    style: {},
  },
  fields: [
    { name: 'heading', label: 'Heading (optional)', type: 'text', placeholder: 'Follow Me' },
  ],
};

// Available social platforms with profile field mappings
export const socialPlatforms = [
  { value: 'youtube', label: 'YouTube', profileField: 'socialLinks.youtube', urlTemplate: (v) => v.startsWith('http') ? v : `https://youtube.com/@${v}` },
  { value: 'twitter', label: 'Twitter / X', profileField: 'socialLinks.twitter', urlTemplate: (v) => v.startsWith('http') ? v : `https://twitter.com/${v}` },
  { value: 'twitch', label: 'Twitch', profileField: 'socialLinks.twitch', urlTemplate: (v) => v.startsWith('http') ? v : `https://twitch.tv/${v}` },
  { value: 'instagram', label: 'Instagram', profileField: 'socialLinks.instagram', urlTemplate: (v) => v.startsWith('http') ? v : `https://instagram.com/${v}` },
  { value: 'facebook', label: 'Facebook', profileField: 'socialLinks.facebook', urlTemplate: (v) => v.startsWith('http') ? v : `https://facebook.com/${v}` },
  { value: 'discord', label: 'Discord', profileField: 'socialLinks.discord', urlTemplate: (v) => v.startsWith('http') ? v : `https://discord.gg/${v}` },
  { value: 'tiktok', label: 'TikTok', profileField: 'socialLinks.tiktok', urlTemplate: (v) => v.startsWith('http') ? v : `https://tiktok.com/@${v}` },
  { value: 'linkedin', label: 'LinkedIn', profileField: 'socialLinks.linkedin', urlTemplate: (v) => v.startsWith('http') ? v : `https://linkedin.com/in/${v}` },
  { value: 'github', label: 'GitHub', profileField: 'socialLinks.github', urlTemplate: (v) => v.startsWith('http') ? v : `https://github.com/${v}` },
  { value: 'website', label: 'Website', profileField: 'socialLinks.website', urlTemplate: (v) => v.startsWith('http') ? v : `https://${v}` },
  { value: 'chesscom', label: 'Chess.com', profileField: 'links.chessCom', urlTemplate: (v) => `https://chess.com/member/${v}` },
  { value: 'lichess', label: 'Lichess', profileField: 'links.lichess', urlTemplate: (v) => `https://lichess.org/@/${v}` },
  { value: 'fide', label: 'FIDE', profileField: 'links.fideId', urlTemplate: (v) => `https://ratings.fide.com/profile/${v}` },
];
